import { Component, Prop, Watch } from "vue-property-decorator";
import baseUserContextProductComponent from "../baseUserContextProductComponent";
import Vue from "vue";
import { get } from "lodash";
import { BvModalEvent } from "bootstrap-vue";
import { AddToOfferRequest, AddToOfferResponse, OfferProductModel, OfferToCart, ShoppingOfferModel, UpdateOfferProduct, UpdateOfferRequest, UpsertOfferProduct } from "@/models/offerModel";
import axios from "axios";
import { umDefinition } from "@/models/umDefinition";
import { sisasListiniModel } from "@/models/sisasPimListiniModel";
import { ShoppingCartModel } from "@/models/shoppingCartModel";
import { mapMutations } from "vuex";
import moment from "moment";
import { QuotationPdfRequest } from "@/models/quotationPdfRequest";
import { Callbacks } from "jquery";

@Component({
    methods: {
        ...mapMutations(["setCurrentOffer"])
    }
})
export default class cartOfferPanel extends baseUserContextProductComponent {
    @Prop({ default: false })
    showGenerateCart: boolean;
    @Prop({ default: true })
    showGenerateQuotation: boolean;
    @Prop({ default: false })
    showPrintQuotation: boolean;
    @Prop({ default: false })
    isReadOnly: boolean;
    @Prop({ default: false })
    showDeleteOffer: boolean;
    @Prop({ default: false })
    showUpdateOffer: boolean;

    @Prop({ default: () => [] })
    listini: sisasListiniModel[];

    @Prop({ default: () => [] })
    offerCart: ShoppingOfferModel;

    setCurrentOffer!: (cart: ShoppingCartModel | null) => void;

    lastRechargeValueModified: string = "";
    lastMarginValueModified: string = "";

    show: boolean = true;

    productsInOffer: OfferProductModel[] = [];

    stringLength: number = 10;

    currentProductsInOffer: string = null;
    currentOfferHeader: any = null;

    fields: any = [
        { key: "code", label: "Codice" },
        { key: "name", label: "Descrizione" },
        { key: "quantity", label: "Quantita'" },
        { key: "unitSellingPrice", label: "Prezzo Listino" },
        { key: "unitNetPrice", label: "Prezzo Acquisto" },
        { key: "recharge", label: "Ricarico %" },
        { key: "margin", label: "Margine %" },
        { key: "profit", label: "Guadagno" },
        { key: "publicPrice", label: "Prezzo vendita pubblico" },
        { key: "delete", label: "Elimina dati" }
    ];

    created() {
        let products = JSON.parse(JSON.stringify(this.offerCart.products)) as OfferProductModel[];

        const groupedBySku = new Map();

        if (products && products.length) {
            products.forEach((cartProduct) => {
                const sku = cartProduct.sku;

                if (groupedBySku.has(sku)) {
                    groupedBySku.get(sku).push(cartProduct);
                } else {
                    groupedBySku.set(sku, [cartProduct]);
                }
            });

            const uniqueProducts = [];

            groupedBySku.forEach((productsArray: OfferProductModel[]) => {
                const totalQuantity = productsArray.reduce((sum, currentProduct) => sum + currentProduct.quantity, 0);
                const totalRowNetTotal = productsArray.reduce((sum, currentProduct) => sum + (currentProduct.rowNetTotal || 0), 0);
                const unitNetPrice = totalQuantity !== 0 ? totalRowNetTotal / totalQuantity : 0;

                const maxSellingPriceProduct = productsArray.reduce((maxProduct, currentProduct) => {
                    return currentProduct.unitSellingPrice > (maxProduct ? maxProduct.unitSellingPrice : -Infinity) ? currentProduct : maxProduct;
                }, null);

                if (maxSellingPriceProduct) {
                    maxSellingPriceProduct.quantity = totalQuantity;
                    maxSellingPriceProduct.unitNetPrice = unitNetPrice;
                    uniqueProducts.push(maxSellingPriceProduct);
                }
            });

            // Ora uniqueProducts contiene gli oggetti distinti con il "unitSellingPrice" più alto per ogni 'sku'
            this.productsInOffer = uniqueProducts;
        } else {
            this.productsInOffer = [];
        }

        this.currentProductsInOffer = JSON.stringify(this.productsInOffer);

        const { referenceCode, businessName, address, cell, email } = this.offerCart;

        this.currentOfferHeader = {
            referenceCode: referenceCode,
            businessName: businessName,
            address: address,
            cell: cell,
            email: email
        };
    }

    // @Watch("cart", { deep: true })
    // onCartChange(newVal: any) {
    //     if (newVal == null || newVal.products == null) return [];

    //     let products = JSON.parse(JSON.stringify(newVal.products)) as OfferProductModel[];

    //     console.log(newVal.products);

    //     products.pop();
    //     products[1].quantity = 30;
    //     products[1].unitNetPrice = this.totalForPice(30, products[1].productId);

    //     this.productsInOffer = products;
    // }

    onPublicPriceChange(item: OfferProductModel) {
        let publicPrice = parseFloat(item.publicPrice as any);
        let profit = 0;
        let margin = 0;
        let recharge = 0;

        console.log(item.unitNetPrice);

        if (item.unitNetPrice > 0 && publicPrice > 0) {
            profit = publicPrice - item.unitNetPrice;
            recharge = (100 * profit) / item.unitNetPrice;
            margin = ((publicPrice - item.unitNetPrice) / publicPrice) * 100;

            Vue.set(item, "recharge", parseFloat(recharge.toFixed(2)));
            Vue.set(item, "margin", parseFloat(margin.toFixed(2)));
            Vue.set(item, "profit", parseFloat(profit.toFixed(2)));
            Vue.set(item, "publicPrice", parseFloat(publicPrice as any).toFixed(2));
        } else if (publicPrice == 0) {
            Vue.set(item, "recharge", 0);
            Vue.set(item, "margin", 0);
            Vue.set(item, "profit", 0);
            Vue.set(item, "publicPrice", 0);
        }
    }

    onProfitChange(item: OfferProductModel) {
        let publicPrice = 0;
        let profit = parseFloat(item.profit as any);
        let margin = 0;
        let recharge = 0;

        if (item.unitNetPrice > 0 && profit > 0) {
            recharge = (100 * profit) / item.unitNetPrice;
            publicPrice = item.unitNetPrice + profit;
            margin = ((publicPrice - item.unitNetPrice) / publicPrice) * 100;

            Vue.set(item, "recharge", parseFloat(recharge.toFixed(2)));
            Vue.set(item, "margin", parseFloat(margin.toFixed(2)));
            Vue.set(item, "publicPrice", parseFloat(publicPrice.toFixed(2)));
            Vue.set(item, "profit", parseFloat(profit as any).toFixed(2));
        } else if (profit == 0) {
            Vue.set(item, "recharge", 0);
            Vue.set(item, "margin", 0);
            Vue.set(item, "profit", 0);
            Vue.set(item, "publicPrice", 0);
        }
    }

    onMarginChange(item: OfferProductModel) {
        let publicPrice = 0;
        let profit = 0;
        let margin = parseFloat(item.margin as any);
        let recharge = 0;

        if (item.unitNetPrice > 0 && margin > 0) {
            publicPrice = (item.unitNetPrice * 100) / (100 - margin);
            profit = publicPrice - item.unitNetPrice;
            recharge = (100 * profit) / item.unitNetPrice;

            Vue.set(item, "recharge", parseFloat(recharge.toFixed(2)));
            Vue.set(item, "publicPrice", parseFloat(publicPrice.toFixed(2)));
            Vue.set(item, "profit", parseFloat(profit.toFixed(2)));
            Vue.set(item, "margin", parseFloat(margin as any).toFixed(2));

            this.lastMarginValueModified = parseFloat(margin as any).toFixed(2);
        } else if (margin == 0) {
            Vue.set(item, "recharge", 0);
            Vue.set(item, "margin", 0);
            Vue.set(item, "profit", 0);
            Vue.set(item, "publicPrice", 0);

            this.lastMarginValueModified = "0";
        }
    }

    onRechargeChange(item: OfferProductModel) {
        let publicPrice = 0;
        let profit = 0;
        let margin = 0;
        let recharge = parseFloat(item.recharge as any);

        if (item.unitNetPrice > 0 && recharge > 0) {
            profit = (item.unitNetPrice * recharge) / 100;
            publicPrice = item.unitNetPrice + profit;
            margin = ((publicPrice - item.unitNetPrice) / publicPrice) * 100;

            Vue.set(item, "margin", parseFloat(margin.toFixed(2)));
            Vue.set(item, "publicPrice", parseFloat(publicPrice.toFixed(2)));
            Vue.set(item, "profit", parseFloat(profit.toFixed(2)));
            Vue.set(item, "recharge", parseFloat(recharge as any).toFixed(2));

            this.lastRechargeValueModified = parseFloat(recharge as any).toFixed(2);
        } else if (recharge == 0) {
            Vue.set(item, "recharge", 0);
            Vue.set(item, "margin", 0);
            Vue.set(item, "profit", 0);
            Vue.set(item, "publicPrice", 0);

            this.lastRechargeValueModified = "0";
        }
    }

    onCopyValueOnAllColumn(typeOfValue: string) {
        if (typeOfValue == "margin" && this.lastMarginValueModified) {
            let margin = parseFloat(this.lastMarginValueModified as any);
            if (margin > 0) {
                for (var i = 0; i < this.productsInOffer.length; i++) {
                    let item = this.productsInOffer[i];
                    if (item.unitNetPrice > 0) {
                        let publicPrice = (item.unitNetPrice * 100) / (100 - margin);
                        let profit = publicPrice - item.unitNetPrice;
                        let recharge = (100 * profit) / item.unitNetPrice;

                        Vue.set(item, "recharge", parseFloat(recharge.toFixed(2)));
                        Vue.set(item, "publicPrice", parseFloat(publicPrice.toFixed(2)));
                        Vue.set(item, "profit", parseFloat(profit.toFixed(2)));
                        Vue.set(item, "margin", parseFloat(margin as any).toFixed(2));
                    }
                }
            } else if (margin == 0) {
                for (var i = 0; i < this.productsInOffer.length; i++) {
                    let item = this.productsInOffer[i];
                    Vue.set(item, "recharge", 0);
                    Vue.set(item, "margin", 0);
                    Vue.set(item, "profit", 0);
                    Vue.set(item, "publicPrice", 0);
                }
            }
        } else if (typeOfValue == "recharge" && this.lastRechargeValueModified) {
            let recharge = parseFloat(this.lastRechargeValueModified as any);
            if (recharge > 0) {
                for (var i = 0; i < this.productsInOffer.length; i++) {
                    let item = this.productsInOffer[i];
                    if (item.unitNetPrice > 0) {
                        let profit = (item.unitNetPrice * recharge) / 100;
                        let publicPrice = item.unitNetPrice + profit;
                        let margin = ((publicPrice - item.unitNetPrice) / publicPrice) * 100;

                        Vue.set(item, "margin", parseFloat(margin.toFixed(2)));
                        Vue.set(item, "publicPrice", parseFloat(publicPrice.toFixed(2)));
                        Vue.set(item, "profit", parseFloat(profit.toFixed(2)));
                        Vue.set(item, "recharge", parseFloat(recharge as any).toFixed(2));
                    }
                }
            } else if (recharge == 0) {
                for (var i = 0; i < this.productsInOffer.length; i++) {
                    let item = this.productsInOffer[i];
                    Vue.set(item, "recharge", 0);
                    Vue.set(item, "margin", 0);
                    Vue.set(item, "profit", 0);
                    Vue.set(item, "publicPrice", 0);
                }
            }
        } else {
            this.$notify({
                title: "Copia Valore",
                text: `Modifica prima una cella di quella colonna per copiarla su tutte le righe`,
                type: "warn",
                group: "msg"
            });
        }
    }

    onDeleteValueAllColumns() {
        for (var i = 0; i < this.productsInOffer.length; i++) {
            let item = this.productsInOffer[i];
            Vue.set(item, "recharge", null);
            Vue.set(item, "margin", null);
            Vue.set(item, "profit", null);
            Vue.set(item, "publicPrice", null);
        }
    }

    onDeleteValueRow(item) {
        Vue.set(item, "recharge", null);
        Vue.set(item, "margin", null);
        Vue.set(item, "profit", null);
        Vue.set(item, "publicPrice", null);
    }

    onGenerateOfferCode() {
        let code = this.generateString();
        Vue.set(this.offerCart, "referenceCode", code);
    }

    generateString() {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let result = "";
        const charactersLength = characters.length;

        for (let i = 0; i < this.stringLength; i++) {
            const randomIndex = Math.floor(Math.random() * charactersLength);
            result += characters.charAt(randomIndex);
        }

        return result;
    }

    onCreateCart() {
        var self = this;

        this.$bvModal
            .msgBoxConfirm("Sei sicuro di voler creare un carrello da questa offerta (il carrello attuale verrà svuotato e l'offerta verrà eliminata)?", {
                contentClass: "border-warning",
                headerBgVariant: "warning",
                title: "Attenzione",
                size: "md",
                buttonSize: "sm",
                okVariant: "warning",
                okTitle: "SI",
                cancelTitle: "NO",
                hideHeaderClose: false,
                centered: true
            })
            .then((value) => {
                if (value == true) {
                    self.setPageLoading(true);
                    let request: OfferToCart = {
                        offerId: self.offerCart.id,
                        referenceCode: self.offerCart.referenceCode
                    };

                    let customerId = self.getCurrentCustomer.id;

                    axios
                        .post<ShoppingCartModel>(`cart/offer/tocart/${customerId}`, request)
                        .then((res) => {
                            self.$notify({
                                title: "Creazione Carrello",
                                text: `Il carrello è stato creato con successo`,
                                type: "success",
                                group: "msg"
                            });

                            self.setCurrentCart(res.data);
                            self.setPageLoading(false);

                            self.$router.push("/cart");
                        })
                        .catch((error) => {
                            console.error(error);
                            self.setPageLoading(false);
                        });
                }
            })
            .catch((err) => {});
    }

    onPreBuyOffer() {
        var self = this;
        this.setPageLoading(true);
        // let request: OfferToCart = {
        //     offerId: this.offerCart.id,
        //     referenceCode: this.offerCart.referenceCode
        // };

        let customerId = this.getCurrentCustomer.id;
        let offerId = this.offerCart.id;

        axios
            .get<ShoppingCartModel>(`cart/offer/detail/${customerId}/${offerId}`)
            .then((res) => {
                // self.$notify({
                //     title: "Creazione Carrello",
                //     text: `Il carrello è stato creato con successo`,
                //     type: "success",
                //     group: "msg"
                // });
                self.setPageLoading(false);
                (res.data as any).customerReferentCode = self.offerCart.referenceCode;
                (res.data as any).validTo = self.offerCart.validTo;
                self.setCurrentOffer(res.data);

                self.$router.push({ name: "checkoutoffer" });
                //self.setCurrentCart(res.data);
            })
            .catch((error) => {
                console.error(error);
                self.setPageLoading(false);
            });

        // axios
        //     .post<ShoppingCartModel>(`cart/offer/tocart/${customerId}`, request)
        //     .then((res) => {
        //         self.$notify({
        //             title: "Creazione Carrello",
        //             text: `Il carrello è stato creato con successo`,
        //             type: "success",
        //             group: "msg"
        //         });

        //         self.setCurrentCart(res.data);
        //         self.setPageLoading(false);
        //     })
        //     .catch((error) => {
        //         console.error(error);
        //         self.setPageLoading(false);
        //     });
    }

    onUpsertOffer() {
        if (!this.offerCart.referenceCode) {
            this.$notify({
                title: "",
                text: "Il codice dell'offerta è obbligatorio",
                type: "error",
                group: "msg"
            });

            return;
        }

        if (this.isValidValue == false) {
            this.$notify({
                title: "",
                text: "Controllare i valori: uno o più sono negativi!",
                type: "error",
                group: "msg"
            });

            return;
        }

        if (this.productsInOffer && this.productsInOffer.length) {
            let customerId = this.getCurrentCustomer.id;
            let code = this.offerCart.referenceCode;
            let businessName = this.offerCart.businessName;
            let address = this.offerCart.address;
            let cell = this.offerCart.cell;
            let email = this.offerCart.email;

            let request: AddToOfferRequest = {
                customerId: customerId,
                code: code,
                address: address,
                businessName: businessName,
                cell: cell,
                email: email,

                products: []
            };

            for (var i = 0; i < this.productsInOffer.length; i++) {
                let p = this.productsInOffer[i];
                let productsInCart = this.offerCart.products.filter((x) => x.sku == p.sku || x.productId == p.productId);

                for (var j = 0; j < productsInCart.length; j++) {
                    let prCart = productsInCart[j];
                    let productOffer: UpsertOfferProduct = {
                        customerId: customerId,
                        productId: p.productId,
                        sku: p.sku,
                        quantity: prCart.quantity,
                        margin: parseFloat(p.margin as any),
                        profit: parseFloat(p.profit as any),
                        publicPrice: parseFloat(p.publicPrice as any),
                        recharge: parseFloat(p.recharge as any)
                    };

                    request.products.push(productOffer);
                }
            }

            var self = this;
            this.setPageLoading(true);

            axios
                .post<AddToOfferResponse>(`cart/offer/${customerId}`, request)
                .then((res) => {
                    if (res && res.data && res.data.error) {
                        if (res.data.message) {
                            self.$notify({
                                title: "Errore nell'aggiornamento del preventivo",
                                text: `${res.data.message}`,
                                type: "error",
                                group: "msg"
                            });
                        }

                        return;
                    }
                    self.$notify({
                        title: "Creazione Preventivo",
                        text: `Il preventivo con codice '${code}' è stato creato`,
                        type: "success",
                        group: "msg"
                    });
                    self.offerCart.referenceCode = null;
                    self.$emit("onCloseOfferPanel");

                    if (res && res.data && res.data.cart) {
                        self.setCurrentCart(res.data.cart);
                    }
                })
                .catch((error) => {
                    self.setPageLoading(false);
                    console.error(error);
                })
                .finally(() => {
                    self.setPageLoading(false);
                });
        } else {
            this.$notify({
                title: "",
                text: "Nessun prodotto presente per il preventivo",
                type: "error",
                group: "msg"
            });
        }
    }

    onHideOfferPanel(e: BvModalEvent) {
        e.preventDefault();
    }

    onCloseOfferPanel(e: BvModalEvent) {
        e.preventDefault();

        this.offerCart.referenceCode = null;
        this.offerCart.address = null;
        this.offerCart.cell = null;
        this.offerCart.email = null;
        this.offerCart.businessName = null;

        this.$emit("onCloseOfferPanel");
    }

    onCreateQuotationPdf() {
        var self = this;
        var callback = function () {
            self.setPageLoading(true);

            let customerId = self.getCurrentCustomer.id;
            let offerId = self.offerCart.id;

            let request: QuotationPdfRequest = {
                businessName: self.offerCart.businessName,
                email: self.offerCart.email,
                address: self.offerCart.address,
                cell: self.offerCart.cell
            };

            axios
                .post(`cart/offer/pdf/${customerId}/${offerId}`, request, {
                    responseType: "blob"
                })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", `Preventivo: ${self.offerCart.referenceCode}.pdf`);
                    document.body.appendChild(fileLink);

                    fileLink.click();

                    URL.revokeObjectURL(fileLink.href);
                    document.body.removeChild(fileLink);

                    self.setPageLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    self.setPageLoading(false);
                });
        };

        if (this.hasNotChanges) {
            callback();
        } else {
            this.onUpdateOffer(callback);
        }
    }

    onDeleteOffer() {
        var self = this;
        let customerId = this.getCurrentCustomer.id;
        let offerId = this.offerCart.id;
        let code = this.offerCart.referenceCode;

        this.$bvModal
            .msgBoxConfirm("Sei sicuro di voler eliminare l'offerta: " + code, {
                contentClass: "border-warning",
                headerBgVariant: "warning",
                title: "Attenzione",
                size: "md",
                buttonSize: "sm",
                okVariant: "warning",
                okTitle: "SI",
                cancelTitle: "NO",
                hideHeaderClose: false,
                centered: true
            })
            .then((value) => {
                if (value == true) {
                    axios
                        .delete(`cart/offer/${customerId}/${offerId}`)
                        .then((response) => {
                            self.$notify({
                                title: "Eliminazione Offerta",
                                text: `L'offerta è stata eliminata con successo`,
                                type: "success",
                                group: "msg"
                            });

                            self.$emit("onDeleteOffer");
                        })
                        .catch((err) => {
                            console.log(err);

                            self.$notify({
                                title: "Eliminazione Offerta",
                                text: `Si è verificato un'errore nell'eliminazione dell'offerta`,
                                type: "success",
                                group: "msg"
                            });
                        });
                }
            })
            .catch((err) => {});
    }

    onUpdateOffer(callback: Function = null) {
        if (!this.offerCart.referenceCode) {
            this.$notify({
                title: "",
                text: "Il codice dell'offerta è obbligatorio",
                type: "error",
                group: "msg"
            });

            return;
        }

        if (this.isValidValue == false) {
            this.$notify({
                title: "",
                text: "Controllare i valori: uno o più sono negativi!",
                type: "error",
                group: "msg"
            });

            return;
        }

        if (this.productsInOffer && this.productsInOffer.length) {
            let customerId = this.getCurrentCustomer.id;
            let code = this.offerCart.referenceCode;
            let businessName = this.offerCart.businessName;
            let address = this.offerCart.address;
            let cell = this.offerCart.cell;
            let email = this.offerCart.email;
            let offerId = this.offerCart.id;

            let request: UpdateOfferRequest = {
                offerId: offerId,
                customerId: customerId,
                code: code,
                address: address,
                businessName: businessName,
                cell: cell,
                email: email,

                products: []
            };

            for (var i = 0; i < this.productsInOffer.length; i++) {
                let p = this.productsInOffer[i];
                let productsInCart = this.offerCart.products.filter((x) => x.sku == p.sku || x.productId == p.productId);

                for (var j = 0; j < productsInCart.length; j++) {
                    let prCart = productsInCart[j];
                    let productOffer: UpdateOfferProduct = {
                        itemId: (prCart as any).id,
                        customerId: customerId,
                        productId: p.productId,
                        sku: p.sku,
                        quantity: prCart.quantity,
                        margin: parseFloat(p.margin as any),
                        profit: parseFloat(p.profit as any),
                        publicPrice: parseFloat(p.publicPrice as any),
                        recharge: parseFloat(p.recharge as any)
                    };

                    request.products.push(productOffer);
                }
            }

            var self = this;

            this.setPageLoading(true);

            axios
                .post<UpdateOfferRequest>(`cart/offer/update/${customerId}/${offerId}`, request)
                .then((res) => {
                    if (res && res.data && res.data.error) {
                        if (res.data.message) {
                            self.$notify({
                                title: "Errore nell'aggiornamento del preventivo",
                                text: `${res.data.message}`,
                                type: "error",
                                group: "msg"
                            });
                        }

                        return;
                    }
                    self.$notify({
                        title: "Aggiornamento Preventivo",
                        text: `Il preventivo con codice '${code}' è stato aggiornato`,
                        type: "success",
                        group: "msg"
                    });

                    if (callback) {
                        self.currentProductsInOffer = JSON.stringify(self.productsInOffer);

                        const { referenceCode, businessName, address, cell, email } = self.offerCart;

                        self.currentOfferHeader = {
                            referenceCode: referenceCode,
                            businessName: businessName,
                            address: address,
                            cell: cell,
                            email: email
                        };

                        callback();
                    } else {
                        self.offerCart.referenceCode = null;
                        self.$emit("onCloseOfferPanel");
                        self.$emit("onFetchList");
                    }
                })
                .catch((error) => {
                    self.setPageLoading(false);
                    console.error(error);
                })
                .finally(() => {
                    if (!callback) {
                        self.setPageLoading(false);
                    }
                });
        } else {
            this.$notify({
                title: "",
                text: "Nessun prodotto presente per il preventivo",
                type: "error",
                group: "msg"
            });
        }
    }

    get isValidValue() {
        let isValid = true;
        for (var i = 0; i < this.productsInOffer.length; i++) {
            let p = this.productsInOffer[i] as any;

            let productOffer: any = {
                margin: parseFloat(p.margin),
                profit: parseFloat(p.profit),
                publicPrice: parseFloat(p.publicPrice),
                recharge: parseFloat(p.recharge)
            };

            if (productOffer.margin < 0 || productOffer.profit < 0 || productOffer.publicPrice < 0 || productOffer.recharge < 0) {
                isValid = false;
                break;
            }
        }

        return isValid;
    }

    get stateOfferCode() {
        if (this.offerCart.referenceCode != null) {
            if (this.offerCart.referenceCode.length > 0) {
                return true;
            }

            return false;
        }

        return null;
    }

    get invalidOfferCart() {
        if (!this.offerCart.referenceCode || this.offerCart.referenceCode.length <= 0) {
            return "Il riferimento dell'offerta è obbligatorio";
        }

        return null;
    }

    get getTotalQuantity() {
        let totalQuantity = this.productsInOffer.reduce((sum, currentProduct) => sum + (currentProduct.quantity || 0), 0);
        return totalQuantity;
    }

    get getTotalNetQuantity() {
        if (this.offerCart && this.offerCart.products && this.offerCart.products.length) {
            let netTotal = this.offerCart.products.reduce((sum, currentProduct) => sum + (currentProduct.rowNetTotal || 0), 0);
            return netTotal;
        }

        return 0;
    }

    get getTotalPublicPrice() {
        let totalPublicPrice = this.productsInOffer.reduce((sum, currentProduct) => sum + (currentProduct.quantity * currentProduct.publicPrice || 0), 0);

        return totalPublicPrice;
    }

    get getTotalProfit() {
        let totalProfit = this.productsInOffer.reduce((sum, currentProduct) => sum + (currentProduct.quantity * currentProduct.profit || 0), 0);

        return totalProfit;
    }

    get showGenerateCartBtn() {
        return this.showGenerateCart && this.isValidOffer;
    }

    get isValidOffer() {
        if (this.offerCart) {
            if (!this.offerCart.validTo) return true;

            let now = moment().startOf("day");
            return now <= moment(this.offerCart.validTo);
        }

        return false;
    }

    get hasNotChanges() {
        if (JSON.stringify(this.productsInOffer) != this.currentProductsInOffer) {
            return false;
        }

        const { referenceCode, businessName, address, cell, email } = this.offerCart;
        if (
            referenceCode != this.currentOfferHeader.referenceCode ||
            businessName != this.currentOfferHeader.businessName ||
            address != this.currentOfferHeader.address ||
            cell != this.currentOfferHeader.cell ||
            email != this.currentOfferHeader.email
        ) {
            return false;
        }

        return true;
    }
}
